import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { ReservationType } from '@/types/servicesTypes/Bookings.types'

import { FiltersSharedProps } from './Filters.types'

interface ReservationTypeFilterProps extends FiltersSharedProps {
  title: string
  reservationTypes?: ReservationType
  initialValue?: string[]
  onChange: (value?: string[]) => void
  isLoadingOptions?: boolean
}

const _ReservationTypeFilter: FC<ReservationTypeFilterProps> = ({ reservationTypes, ...props }) => {
  const reservationTypeOptions =
    reservationTypes?.map(type => ({
      label: type.name,
      value: type.id,
    })) || []

  return <CheckboxBasedFilter options={reservationTypeOptions} {...props} />
}

export const ReservationTypeFilter = observer(_ReservationTypeFilter)
